<template>
<section class="follow">
   <div class="animationLayer first">
      <div class="slideContainer"><img src="@/assets/images/follow_img1.png"></div>
  </div>
   <div class="animationLayer secound">
      <div class="slideContainer"><img src="@/assets/images/follow_img2.png"></div>
  </div>
   <div class="animationLayer third">
      <div class="slideContainer"><img src="@/assets/images/follow_img3.png"></div>
  </div>
  <div class="container">
    <div class="inner">
      <h3 class="title"><img v-if="isEdge" src="@/assets/images/followus.png" alt="FOLLOW US!!"></h3>
      <ul class="icons">
        <li><a href="https://www.facebook.com/MAMADAYS/" target="_blank"><img class="hover" src="@/assets/images/icons/hover/facebook.png"><img class="normal" src="@/assets/images/icons/page/facebook.png"></a></li>
        <li><a href="https://www.instagram.com/mamadaystv/" target="_blank"><img class="hover" src="@/assets/images/icons/hover/instagram.png"><img class="normal" src="@/assets/images/icons/page/instagram.png"></a></li>
        <li><a href="https://www.youtube.com/channel/UC26H3H7aEUnMwF7hztP07Og" target="_blank"><img class="hover" src="@/assets/images/icons/hover/youtube.png"><img class="normal" src="@/assets/images/icons/page/youtube.png"></a></li>
        <li><a href="https://twitter.com/mamadaystv" target="_blank"><img class="hover" src="@/assets/images/icons/hover/twitter.png"><img class="normal" src="@/assets/images/icons/page/twitter.png"></a></li>
      </ul>
      <p class="text">MAMADAYSのSNSアカウントにて、総選挙の受賞商品や子育てに役立つ情報を紹介中♪</p>
    </div>
  </div>
</section>

<section class="special">
  <div class="infoContainer">
    <section class="aboutApp">
      <figure class="titleImage"><img src="@/assets/images/nav_mamadays.png" alt="MAMA DAYS"></figure>
      <h3 class="title">MAMADAYS公式アプリ</h3>
      <p class="text">毎日の子育てをアプリ１つで！<br/>離乳食も育児記録もこれさえあれば困らない。</p>
      <div class="appLinks">
        <p class="apple"><a target="_blank" href="https://app.adjust.com/yta7f5j"><img src="@/assets/images/appstore.png" alt="App Store"></a></p>
        <p class="googlePlay"><a target="_blank" href="https://app.adjust.com/yta7f5j"><img src="@/assets/images/googleplay.png" alt="Google Play"></a></p>
      </div>
    </section>
    <section class="shop">
      <figure class="titleImage"><img src="@/assets/images/mamadays_shop_footer.png" alt="MAMA DAYS SHOP"></figure>
      <h3 class="title">ママパパの365日に<br class="is_sp">寄り添うショップ</h3>
      <p class="text">育児をもっと楽しく、家事をもっと楽に！<br/>日々の悩みを解決してくれるような商品を<br/>数多く取り揃えています。</p>
      <a class="button" v-bind:href="onlineShopUrl" target="_blank"><span class="textEl">人気商品をチェック</span><span class="bg"></span></a>
    </section>
  </div>
  <div class="animationContainer">
    <div class="animationLayer">
      <div class="slideContainer"><p><img src="@/assets/images/specialthanks.png" alt="SPECIAL THANKS!"></p></div>
      <div class="slideContainer"><p><img src="@/assets/images/specialthanks.png" alt="SPECIAL THANKS!"></p></div>
    </div>
  </div>
</section>

<footer>
  <section class="check">
    <h3 class="title">MAMADAYS<br class="is_sp">公式サイトをCHECK！</h3>
    <p class="text">最新情報をCHECKしたい方は<br>公式サイトを是非ご覧ください。</p>
    <a class="button" href="https://mamadays.tv/" target="_blank"><span class="textEl"><img src="@/assets/images/mamdays_button.png" alt="MAMADAYS"></span><span class="bg"></span></a>
    <figure class="phone"><img src="@/assets/images/footer_photo.png"></figure>
  </section>
  <section class="linkArea">
    <p class="copywrite en">© EVERY,INC. 2019-2021</p>
    <ul class="links">
      <li><router-link :to="{path:'/'}">トップ</router-link></li>
      <li><a href="https://mamadays.tv/contact" target="_blank">お問い合わせ</a></li>
      <li><a href="https://corp.every.tv/" target="_blank">運営会社</a></li>
      <li><a href="https://mamadays.tv/terms" target="_blank">利用規約</a></li>
      <li><a href="https://corp.every.tv/privacy" target="_blank">プライバシーポリシー</a></li>
    </ul>
    <p class="chick"></p>
  </section>
</footer>
</template>

<script>
import store from '@/store/index'
import lottie from 'lottie-web'
import util from '@/jsUtil/util'
import { debounce } from 'throttle-debounce';
export default {
  name: 'Footer',

  data () {
    return {
      events: {},
      onlineShopUrl: "https://shop.mamadays.tv/",
      chickAnimation: null,
      cacheWidth: 0,
      isEdge: false,
      followTitleAnimation: null,
      isAllowFollowAnimation: false
    }
  },

  mounted(){
    this.unsubscribe = store.subscribe((mutation, state) => {
      switch(mutation.type) {
        case "setOnlineShopUrl":
          this.onlineShopUrl = state.onlineShopUrl
          break;
        case "readyToSetFollowAnimation":
          if (!this.isEdge && this.followTitleAnimation) {
            this.isAllowFollowAnimation = true;
            this.followTitleAnimation.goToAndStop(0);
          }
          break;
        case "stopToSetFollowAnimation":
          if (!this.isEdge && this.followTitleAnimation) {
            this.isAllowFollowAnimation = false;
          }
          break;
      }
    });

    this.checkEdge();
    if (!this.isEdge) {
      this.generateFollowUs();
      this.scrollEvents();
    }
    this.generateChick();
    this.setWindowSizeCheck();

  },

  methods: {

    checkEdge() {
      // followus lottieアニメーションがIE未対応なためブラウザ判定
      const ua = window.navigator.userAgent.toLowerCase();
      const isEdge = ua.indexOf('edge') != -1;
      this.isEdge = isEdge;
    },

    scrollEvents() {
      const followTitleEl = document.querySelector(".follow .container .title");
      const followFlgEl = document.querySelector(".follow");
      this.events["scrollEvents"] = () => {
        const currentScroll = util.getScrollTop();
        const windowheight = window.outerHeight;
        const followFlgPosition = util.getoffsetTop(followFlgEl);
        const isSpSize = window.outerWidth < 828;
        const coef = isSpSize ? 0.55 : 0.7
        if(currentScroll + (windowheight * coef) >= followFlgPosition) {
          if (this.isAllowFollowAnimation) {
            this.isAllowFollowAnimation = false;
            this.followTitleAnimation.play();
          }
        }
      }
      window.addEventListener("scroll", this.events["scrollEvents"]);
    },

    reloadHorizontalAnimation(){
      const targetsEl = document.querySelectorAll(".animationLayer");
      return debounce(1000, false, () => { 
        const docWidth = document.body.clientWidth;
        if ( Math.abs(this.cacheWidth - docWidth) > 30 ) {
          this.cacheWidth = docWidth;
          targetsEl.forEach((el,i) => {
            el.style.display = "none";
          });
          setTimeout(()=>{
            targetsEl.forEach((el,i) => {
              el.style.display = "flex";
            });
          },300);
        }
      });
    },

    setWindowSizeCheck(){
      this.events["reloadHorizontalAnimation"] = this.reloadHorizontalAnimation();
      window.addEventListener("resize",this.events["reloadHorizontalAnimation"]);
    },

    generateChick(){
      let chickElm = document.querySelector("footer .linkArea .chick");
      this.chickAnimation = lottie.loadAnimation({
        container: chickElm,
        renderer: 'svg',
        loop: true,
        autoplay: false,
        path: '/animations/footer_hiyoko.json'
      });
      this.chickAnimation.play();
    },

    generateFollowUs() {
      let followTitleEl = document.querySelector(".follow .container .title");
      this.followTitleAnimation = lottie.loadAnimation({
        container: followTitleEl,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: '/animations/followus.json'
      });
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

@keyframes loop {
    0% {
      transform: translateX(100%);
    }
    to {
      transform: translateX(-100%);
    }
}

@keyframes loop2 {
    0% {
      transform: translateX(0%);
    }
    to {
      transform: translateX(-200%);
    }
}

@keyframes loop_for_one {
    0% {
      transform: translateX(0%);
    }
    to {
      transform: translateX(-50%);
    }
}

@keyframes inverseloop_for_one {
    0% {
      transform: translateX(-50%);
    }
    to {
      transform: translateX(0%);
    }
}
.follow {
  position: relative;
  background-color: #ffffff;
  overflow: hidden;
  .animationLayer {
      position: absolute;
      z-index: 100;
      overflow: hidden;
      display: flex;
      flex-flow: row nowrap;
      top: -9%;
      width: percent_resize(5282,1920);
      
      .slideContainer {
        width: percent_resize(5282,1920);
        display: flex;
        flex-flow: row nowrap;
        margin: 0;
        padding: 0;
        height: auto;
        animation-play-state: running!important;
        img {
          align-self: flex-start; 
        }
      }
      > div:nth-of-type(1){
          transform: translateX(0%);
          animation: loop_for_one 34s 0s linear infinite;
      }
      &.secound {
        top: 31.5%;
        width: percent_resize(5282,1920);
        > div:nth-of-type(1){
            width: percent_resize(5282,1920);
            transform: translateX(-50%);
            animation: inverseloop_for_one 34s 0s linear infinite;
        }
      }
      &.third {
        top: 74%; 
        width: percent_resize(5824,1920);
        > div:nth-of-type(1){
            width: percent_resize(5824,1920);
            transform: translateX(0%);
            animation: loop_for_one 34s 0s linear infinite;
        }
      }
      > div {
          will-change: transform;
      }
  }
  .container {
    position: relative;
    z-index: 300;
    padding: percent_resize(155,1920) 0 11% 0;
    background: rgba($color: #000000, $alpha: 0.4);
    .inner {
      width: 636px;
      margin: 0 auto;
      text-align: center;
      color: #ffffff;
    }
    .title {
      width: displaysize(740);
      height: 117px;
      margin: 0 auto -4px auto;
      margin-bottom: percent_resize(77,894);
    }
    .text {
      font-size: 14px;
      white-space: nowrap;
    }
    .icons {
      display: flex;
      width: displaysize(400);
      margin: 0 auto percent_resize(56,894) auto;
      justify-content: space-between;
      li {
        position: relative;
        transform: translate(0,0) scale(1);
        will-change: transform;
        @include transition_anim($duration-time: 1.0s);
        img {
          @include transition_anim($duration-time: 1.0s);
        }
        &:hover {
          transform: translate(0,0) scale(1.2);
          .hover { opacity: 1; }
        }
        .hover {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          opacity: 0;
        }
        .normal {
          width: 100%;
        }
        width: percent_resize(70,400);
      }
    }
  }
}

.special {
  background: linear-gradient(180deg, #FFFFFF, #FFFFFF, #FAD882);
  padding-bottom: 9%;
  .infoContainer {
    width: percent_resize(1238,1920);
    padding-top: percent_resize(240,1920);
    padding-bottom: 2%;
    margin: 0 auto;
    max-width: 1200px;
    min-width: 920px;
    @include clearfix;
    section {
      width: percent_resize(520,1238);
      text-align: center;
      .titleImage {
        position: relative;
        height: auto;
        padding-top: percent_resize(156,520);
        margin-bottom: percent_resize(47,520);
        img {
          left: 50%;
          top: 0;
          position: absolute;
          transform: translate(-55%, 0);
        }
      }
      .title {
        font-family: 'M PLUS Rounded 1c', sans-serif;
        font-size: displaysize(35);
        font-weight: bold;
        white-space: nowrap;
        margin-bottom: percent_resize(48,520);
        color: $fontPink;
      }
      .text {
        @include font_style_pc;
        font-size: displaysize(25);
        margin-bottom: percent_resize(46,520);
      }
    }
    .aboutApp {
      float: left;
      .titleImage {
        img { width: percent_resize(156,520); }
      }
      .text {
        margin-bottom: 16.8%;
      }
      .appLinks {
        width: percent_resize(424,520);
        display: flex;
        flex-flow: row nowrap;
        margin: auto;
        a {
          @include hoverlink;
        }
        .apple {
          width: percent_resize(185,424);
          margin-right: percent_resize(30,424);
        }
        .googlePlay {
          width: percent_resize(209,424);
        }
      }
    }
    .shop {
      float: right;
      .title {
        transform: translate(0,0);
        text-align: center;
      }
      .titleImage {
        img { width: percent_resize(160,520); }
      }
      .button {
        @include btn_style(#{displaysize(440)},#{displaysize(60)},$btn_color: $buttonPink,$color: #ffffff);
        height: auto;
        padding: 3% 0 3% 0;
        font-weight: 100;
        margin: 6% auto 0 auto;
        position: relative;
        overflow: hidden;
        z-index: 10;
        will-change: transform;
        transform: translate(0);
        @include transition_anim($duration-time: 0.8s, $propertys: (transform));
        &:hover {
          transform: scale(1.05);
          cursor: pointer;
          &:after {
            width: 600px;
            height: 600px;
          }
          .bg {
            &:after {
              left: 200%;
              opacity: 0;
            }
            &:before {
              left: 50%;
              opacity: 1;
            }
          }
        }
        &:after {
          @include content_pseudo;
          background-color: #bcbcbc;
          width: 0;
          height: 0;
          bottom: -300px;
          border-radius: 50%;
          z-index: 0;
          @include transition_anim($duration-time: 2.0s,$propertys:(width,height));
        }
        .textEl{
          position: relative;
          display: inline-block;
          font-family: 'M PLUS Rounded 1c', sans-serif;
          font-size: 15;
          letter-spacing: 0.1em;
          font-weight: bold;
          line-height: 0;
          padding: 9px 0 9px 0;
          transform: translate(0px, 0);
          z-index: 500;
        }
        .bg {
          display: block;
          position: absolute;
          width: displaysize(30);
          height: displaysize(30);
          right: 12px;
          top: 50%;
          overflow: hidden;
          transform: translate(0,-50%);
          border-radius: 50%;
          border: 2px solid #ffffff;
          z-index: 500;
          &:after {
            @include content_pseudo;
            width: 50%;
            height: 50%;
            left: 50%;
            top: 50%;
            background-image: url("~@/assets/images/icon_arrow_pink_hover.png");
            background-size: 100% auto;
            transform: translate(-50%,-50%);
            opacity: 1;
            will-change: left,opacity;
            @include transition_anim($duration-time: 0.4s,$propertys:(left,opacity));
            transition-timing-function: cubic-bezier(0.76, 0, 0.24, 1);
          }
          &:before {
            @include content_pseudo;
            width: 50%;
            height: 50%;
            left: -100%;
            top: 50%;
            background-image: url("~@/assets/images/icon_arrow_pink_hover.png");
            background-size: 100% auto;
            transform: translate(-50%,-50%);
            opacity: 0;
            will-change: left,opacity;
            @include transition_anim($duration-time: 0.4s,$propertys:(left,opacity));
            transition-timing-function: cubic-bezier(0.76, 0, 0.24, 1);
          }
        }
      }
    }
  }
  
  .animationContainer {
    position: relative;
    padding-top: 29%;
  }

  .animationLayer {
      position: absolute;
      top: 0;
      z-index: 100;
      overflow: hidden;
      display: flex;
      flex-flow: row nowrap;
      width: percent_resize(7300,1920);
      .slideContainer {
          animation-play-state: running!important;
      }
      .slideContainer {
          display: flex;
          flex-flow: row nowrap;
          padding: 0;
          width: 100%;
          color: #ffffff;
          font-weight: lighter;
          letter-spacing: 0.2em;
          white-space: nowrap;
          padding-right: percent_resize(400,7300);
      }
      > div:nth-of-type(1){
          animation: loop 36s -18s linear infinite;
      }
      > div:nth-of-type(2){
          animation: loop2 36s linear infinite;
      }
      > div {
          will-change: transform;
      }
  }
}

footer {
  padding-top: percent_resize(180,1920);
  .check {
    text-align: center;
    width: percent_resize(500,1920);
    max-width: 320px;
    margin: 0 auto percent_resize(180,1920) auto;
    transform: translate(60%,0);
    position: relative;
    z-index: 500;
    .title {
      @include font_style_pc;
      font-size: displaysize(32);
      font-weight: 600;
      white-space: nowrap;
      letter-spacing: 0.13em;
      padding-bottom: percent_resize(28,1920);
      color: $fontPink;
    }
    .text {
      @include font_style_pc;
      font-size: displaysize(29);
      margin-bottom: percent_resize(48,446);
    }
    .button {
      @include btn_style(#{displaysize(450)},40px,$btn_color: $buttonPink,$color: #ffffff);
      height: auto;
      padding: 4% 0 4% 0;
      margin: 0 auto;
      position: relative;
      overflow: hidden;
      z-index: 1000;
      will-change: transform;
      transform: translate(0);
      @include transition_anim($duration-time: 0.8s, $propertys: (transform));
      &:hover {
        transform: scale(1.07);
        cursor: pointer;
        &:after {
          width: 600px;
          height: 600px;
        }
        .bg {
          &:after {
            left: 200%;
            opacity: 0;
          }
          &:before {
            left: 50%;
            opacity: 1;
          }
        }
      }
      .textEl {
        display: inline-block;
        width: displaysize(188);
        font-size: 0;
        line-height: 0;
        z-index: 500;
      }
      &:after {
        @include content_pseudo;
        background-color: #bcbcbc;
        width: 0;
        height: 0;
        bottom: -300px;
        border-radius: 50%;
        z-index: 0;
        @include transition_anim($duration-time: 2.0s,$propertys:(width,height));
      }
      .bg {
        display: block;
        position: absolute;
        width: displaysize(30);
        height: displaysize(30);
        right: 12px;
        top: 50%;
        overflow: hidden;
        transform: translate(0,-50%);
        border-radius: 50%;
        border: 2px solid #ffffff;
        z-index: 500;
        &:after {
          @include content_pseudo;
          width: 50%;
          height: 50%;
          left: 50%;
          top: 50%;
          background-image: url("~@/assets/images/icon_arrow_pink_hover.png");
          background-size: 100% auto;
          transform: translate(-50%,-50%);
          will-change: left,opacity;
          @include transition_anim($duration-time: 0.4s,$propertys:(left,opacity));
          transition-timing-function: cubic-bezier(0.76, 0, 0.24, 1);
        }
        &:before {
          @include content_pseudo;
          width: 50%;
          height: 50%;
          left: -100%;
          top: 50%;
          background-image: url("~@/assets/images/icon_arrow_pink_hover.png");
          background-size: 100% auto;
          transform: translate(-50%,-50%);
          opacity: 0;
          will-change: left,opacity;
          @include transition_anim($duration-time: 0.4s,$propertys:(left,opacity));
          transition-timing-function: cubic-bezier(0.76, 0, 0.24, 1);
        }
      }
    }
    .phone  {
      position: absolute;
      z-index: 600;
      top: -168%;
      left: -162%;
      width: percent_resize(840,446);
      @include resizebywidth_lessthan(1173px){
        top: -150%;
      }
      @include resizebywidth_morethan(1653px){
        top: -195%;
        left: -181%;
        width: 212%;
      }
      @include resizebywidth_morethan(2160px){
        top: -218%;
        left: -196%;
        width: 233%;
      }
    }
  }
  .linkArea {
    position: relative;
    padding: 60px 0 60px 0;
    background-color: $colorGray;
    @include clearfix;
    .copywrite {
      display: inline-block;
      float: left;
      margin-left: displaysize(62);
      font-size: displaysize(18);
    }
    .links {
      float: right;
      display: flex;
      margin-right: displaysize(62);
      @include font_style_pc;
      font-size: displaysize(18);
      li {
        padding-right: displaysize(40);
        position: relative;
        a {
          @include hoverlink
        }
        &:after {
          @include content_pseudo;
          top: 50%;
          right: displaysize(20);
          width: 1px;
          height: 60%;
          transform: translate(0, -50%);
          background-color: $dakenGray;
        }
        &:last-child {
          padding-right: 0;
          &:after {
            display: none;
          }
        }
      }
    }
    .chick {
      width: 157px;
      height: 157px;
      position: absolute;
      top: 0;
      right: -10%;
      transform: translate(0, -151px);
      will-change: right;
      @keyframes moveChick {
        0% { 
          right: -10%;
        }
        100% {
          right: 110%;
        }
      }
      @include animationProp(moveChick, 20.0s, 0.0s, linear);
      animation-iteration-count: infinite;
    }
  }
}

@include resizebywidth_lessthan($base_resize_size){
  .follow {
    .animationLayer {
      width: percent_resize(3500,375);
      top: -7%;
      &.secound {
        width: percent_resize(3500,375);
        top: 30.1%;
      }
      &.third {
        width: percent_resize(3500,375);
        top: 71%;
      }
    }
    .container {
      padding: 13% 0 13% 0;
      .inner {
        width: percent_resize(330,375);
        margin: 0 auto;
        .title {
          width: 95%;
          height: auto;
          padding-top: 25%;
          margin: 0 auto percent_resize(53,330) auto;
          position: relative;
          svg {
            position: absolute;
            left: 0;
            top: 0;
          }
        }
        .text {
          @include font_style_sp;
          font-size: 4.3vw;
          text-align: left;
          white-space: normal;
        }
      }
      .icons {
        width: percent_resize(260,375);
        margin-bottom: percent_resize(45,375);
      }
    }
  }

.special {
  padding-bottom: percent_resize(100,375);
  .infoContainer {
    min-width: auto;
    max-width: initial;
    width: percent_resize(330,375);
    margin: 0 auto;
    padding-top: percent_resize(89,375);
    padding-bottom: 0;
    .aboutApp {
      float: none;
      text-align: center;
      margin-bottom: percent_resize(100,375);
      .titleImage {
        width: percent_resize(103,330);
        padding-top: percent_resize(103,330);
        margin: 0 auto percent_resize(38,330) auto;
        height: auto;
        img { 
          width: 100%;
          transform: translate(-50%, 0);
        }
      }
      .text {
        text-align: center;
        margin-bottom: percent_resize(60,330);
      }
      .viewMore {
        font-size: 4.0vw;
        .circle {
          transform: translate(100%, -51%);
        }
      }
    }
    section {
      width: 100%;
      .title {
        @include font_style_sp;
        font-size: 4.8vw;
        letter-spacing: 0.15em;
        margin-bottom: 4%;
      }
      .text {
        @include font_style_sp;
        font-size: 3.7vw;
        text-align: left;
      }
    }
    .shop {
      margin-bottom: percent_resize(50,375);
      .title {
        transform: none;
      }
      .titleImage {
        width: percent_resize(187,330);
        padding-top: percent_resize(187,330);
        margin: 0 auto percent_resize(52,330) auto;
        height: auto;
        img { 
          width: 100%;
          transform: translate(-50%, 0);
        }
      }
      .text {
        text-align: center;
      }
      .button {
        width: percent_resize(268,330);
        height: auto;
        padding: 3% 0 3% 0;
        .bg {
          width: 6.6%;
          padding-top: 6.6%;
          height: auto;
        }
        .textEl {
          margin-top: -1px;
          padding: 3.3% 0 3.3% 0;
          font-size: 3.0vw;
          width: percent_resize(180,268);
        }
      }
    }
  }

  .animationContainer {
    padding-top: 52%;
  }

  .animationLayer {
      width: percent_resize(2500,375);
      .slideContainer {
          width: percent_resize(1117,375);
          font-weight: 300;
      }
  }
}

footer {
  .check {
    width: 100%;
    transform: none;
    max-width: initial;
    padding-top: percent_resize(490,375);
    margin-bottom: 20%;
    .title {
      @include font_style_sp;
      font-size: 4.8vw;
      margin-bottom: percent_resize(13,375);
    }
    .text {
      @include font_style_sp;
      font-size: 3.7vw;
      margin-bottom: percent_resize(30,375);
    }
    .phone {
      left: -19%;
      top: -24%;
      width: percent_resize(520,375);
      display: block;
    }
    .button {
      width: percent_resize(268,375);
      height: auto;
      padding: 4% 0 4% 0;
      margin-bottom: percent_resize(61,375);
      .bg {
        width: 6.6%;
        padding-top: 6.6%;
        height: auto;
      }
      .textEl {
        margin-top: -2px;
        width: percent_resize(100,268);
      }
    }
  }
  .linkArea {
    position: relative;
    padding: percent_resize(30.2,375) 0 2% 0;
    .copywrite {
      display: block;
      position: absolute;
      width: 100%;
      text-align: center;
      float: none;
      margin: 0;
      font-size: 2.0vw;
      bottom: 9%;
    }
    .links {
      float: none;
      margin: 0 auto percent_resize(40,375) auto;
      width: 58%;
      flex-wrap: wrap;
      justify-content: center;
      li {
        font-size: 2.4vw;
        margin-bottom: 3%;
      }
    }
    .chick {
      width: 100px;
      height: 120px;
      top: 0%;
      transform: translate(0,-116px);
    }
  }
}
}
</style>
